/* eslint-disable no-undef */
import Vue from 'vue'
import App from './App'
import router from './router'
import VueTheMask from 'vue-the-mask'
import axios from 'axios'
import * as VueGoogleMaps from 'vue2-google-maps'
import store from './store/'

import sha1 from 'js-sha1'
import {CONFIG} from '@/config/config'
import {authToken} from '@/assets/js/script'
import {logOut} from '@/assets/js/scripts-login'
import './assets/css/style.css'
import '../static/js/perfect-scrollbar/css/perfect-scrollbar.css'
import '../node_modules/@mdi/font/css/materialdesignicons.min.css'

import VuexRouterSync from 'vuex-router-sync';
VuexRouterSync.sync(store, router);

let protocol = document.location.protocol
let host = document.location.host
let pathname = document.location.pathname
let online = navigator.onLine

if(host.includes(':80') === false && protocol !== 'https:'){
  document.location.href = `https://${host}${pathname}`
}

Vue.use(VueTheMask, axios)
Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA6rCcfg5srq3uwP3HV9Vj13Hf8G2J-IJs' //DEV-KEY: AIzaSyAMkfrYlKehqhGWzBmX3T_KO3IADys1MyY,
  },
  installComponents: true
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data: function () {
    return {
    }
  },
  methods: {
    getMeta () {
      axios.get(`${CONFIG.URL_META_API}/v2/data/${CONFIG.APP_ID}/`)
        .then(response => {
          this.$store.commit('updateMeta', response.data.data.MetaAPI.itens.c2d4f0.value)
        })
        .catch(error => {
          console.error(error)
        })
    },
    setRequestsInterceptors () {
      axios.interceptors.request.use(function (config) {
        if (localStorage.token) {
          config.headers['Authorization'] = `Bearer ${localStorage.token}`
        }

        var hashedMethods = ['post', 'put', 'patch', 'delete']

        if (hashedMethods.includes(config.method) === true) {
          if (config.data && Object.keys(config.data) !== undefined && (config.sha1 === undefined || config.sha1 === true)) {
            config.headers['Content-Checksum'] = `${sha1(JSON.stringify(config.data))}`
          }
        }
        return config
      })

      axios.interceptors.response.use((response) => {
        return response // Nenhuma interferência aqui por enquanto
      }, (error) => {
        let response = error.response
        // Se um token de usuário existe no localStorage e o retorno de qualquer API for 403
        if (response.status === 403 && error.config.url.includes('pessoa-fisica/login') === false) {
          console.info('Token inválido/expirado recusado pela API.')
          logOut()
        } else if (response.status === 401 && error.config.url.includes('auth-api') === false && error.config.url.includes('v1/pessoa-fisica/login') === false) {
          M.toast({html: 'Você não possui permissão de acesso ao recurso solicitado!'})
          this.$router.push('/Censo/')
          return Promise.reject(error)
        } else {
          return Promise.reject(error)
        }
      })
    }
  },
  created () {
    this.setRequestsInterceptors()
    this.getMeta()

    if(online === true){
      authToken()
    }
  },
  mounted () {
  }
})

const prod = process.env.NODE_ENV === 'production'
const shouldSW = 'serviceWorker' in navigator && prod
const shouldSWDev = 'serviceWorker' in navigator && !prod
if (shouldSW) {
  navigator.serviceWorker.register('/service-worker.js', {scope: '/'}).then((reg) => {
    console.log(`Service Worker Registered: ${reg.scope}`)
  })
}



// WEBPACK FOOTER //
// ./src/main.js